import { render, staticRenderFns } from "./BaseChipRadioGroup.vue?vue&type=template&id=6bb629d6"
import script from "./BaseChipRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseChipRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports